import axiosInstance from "../services/secureApi";

export const generateLabelApi = async (orderId) => {
  try {
    const response = await axiosInstance.post(
      `/admin/orders/${orderId}/generate-label`
    );

    return response.data;
  } catch (error) {
    console.error("Generate Label Error:", error.response?.data);
    throw error.response?.data || error;
  }
};